import React, { useEffect, useRef } from "react";
import { t } from "ttag";

import { NavMenuRefsProvider } from "@thelabnyc/thelabui/src/components/ScrollNavMenuBlock";

import { Themed } from "../../styles/themes";

import styles from "./ScrollNavMenuContainer.module.scss";

export const ScrollNavMenuContainer = (props: React.PropsWithChildren) => {
    const fullBleedRef = useRef<HTMLDivElement | null>(null);
    const navLinksRef = useRef<HTMLUListElement | null>(null);

    useEffect(() => {
        const element = fullBleedRef.current;
        /* v8 ignore if -- @preserve */
        if (!element) return;
        const observer = new ResizeObserver(([entry]) => {
            document.documentElement.style.setProperty(
                "--pdp-scroll-nav-height",
                `${entry.contentRect.height}px`,
            );
        });
        observer.observe(element);
        return () => {
            observer.disconnect();
            document.documentElement.style.removeProperty(
                "--pdp-scroll-nav-height",
            );
        };
    }, []);

    return (
        <NavMenuRefsProvider value={{ fullBleedRef, navLinksRef }}>
            <Themed
                theme="white"
                data-id="scroll-nav-menu"
                ref={fullBleedRef}
                className={styles.navMenuFullBleed}
            >
                <nav aria-label={t`On this page`} className={styles.navItems}>
                    <ul ref={navLinksRef} className={styles.navItemList}>
                        {props.children}
                    </ul>
                </nav>
            </Themed>
        </NavMenuRefsProvider>
    );
};
